import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconThumbsDown32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M23 17h1a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1zM21 7H10.638a2 2 0 0 0-1.839 1.212l-2.571 6A2 2 0 0 0 8.066 17h6.688l-.268 2.238-.733 6.106 6.746-7.665.501-.57zm-9.233 18.106L12.26 21l.24-2H8.066c-2.872 0-4.808-2.936-3.676-5.576l2.571-6A4 4 0 0 1 10.638 5H24a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4h-2l-6.745 7.665c-1.298 1.475-3.722.39-3.488-1.56"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown32);
